<template>
  <div
    style="text-align: right;"
  >
    <el-dropdown
      ref="dropDown"
      size="small"
      @command="handleAction"
    >
      <el-button
        size="mini"
        class="el-dropdown-link"
        @click.stop="toggleDropDown"
      >
        <i :class="!buttonLoader ? 'el-icon-more' : 'el-icon-loading'" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-if="inwardHandling.status === 'recorded'"
          v-can="'inwardhandling.update'"
          :command="closeInwardHandling"
          :disabled="buttonLoader"
        >
          <i class="el-icon-check" /> Bevételezés véglegesítése
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'inwardhandling.update'"
          :command="updateInwardHandling"
          :disabled="buttonLoader"
        >
          <i class="el-icon-edit" /> Módosítás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="inwardHandling.status === 'done'"
          v-can="'inwardhandling.update'"
          :command="createCustomerOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-document" /> Vevői megrendelés létrehozása
        </el-dropdown-item>
        <el-dropdown-item
          v-if="inwardHandling.status === 'done'"
          v-can="'inwardhandling.update'"
          :command="createRepresentativeOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-document" /> Raktárközi megrendelés létrehozása
        </el-dropdown-item>
        <el-dropdown-item
          v-if="inwardHandling.status === 'recorded'"
          v-can="'inwardhandling.delete'"
          :command="openDeleteConfirmation"
          :disabled="buttonLoader"
        >
          <i class="el-icon-delete" /> Törlés
        </el-dropdown-item>
        <el-dropdown-item
          :command="exportExcel"
          :disabled="buttonLoader"
        >
          <i class="el-icon-download" /> Excel exportálás
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  export default {
    props: ['inwardHandling'],
    data() {
      return {
        buttonLoader: false,
        deleteConfirmVisible: false,
      };
    },

    methods: {
      async deleteInwardHandling() {
        this.buttonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('inwardHandling/delete', this.inwardHandling.id);
          this.$store.dispatch('inwardHandling/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async updateInwardHandling() {
        this.$router.push('/processes/inward-handlings/update/' + this.inwardHandling.id);
      },
      createCustomerOrder() {
        this.$emit('show-customer-order-dialog', this.inwardHandling.id);
      },
      createRepresentativeOrder() {
        this.$emit('show-representative-order-dialog', this.inwardHandling.id);
      },
      async closeInwardHandling() {
        this.buttonLoader = true;
        try {
          await axios.post('api/inward-handlings/close/' + this.inwardHandling.id);
          this.$store.dispatch('inwardHandling/fetchAll');
        } catch (e) {

        }
        this.buttonLoader = false;
      },
      async openReceipt() {
        if (this.inwardHandling.receipt_path) {
          try {
            const url = await axios.get('api/files?path=' + this.inwardHandling.receipt_path);
            window.open(url);
          } catch (e) {

          }

        }
      },
      openDeleteConfirmation() {
        this.$confirm('Ez a folyamat nem visszafordítható és a kapcsolódó elemek is törölve lesznek.', 'Biztosan törölni szeretnéd?', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
        .then(() => {
          this.deleteInwardHandling();
        })
        .catch(() => {
          this.$router.replace('/processes/inward-handlings');
        });
      },
      handleAction(action) {
        action();
      },
      toggleDropDown() {
        this.$refs['dropDown'].visible = !this.$refs['dropDown'].visible;
      },
      async exportExcel() {
        try {
          this.buttonLoader = true;
          const excel = await axios({
            url: 'api/inward-handlings/' + this.inwardHandling.id + '/export',
            method: 'GET',
            responseType: 'blob',
          });
          saveAs(excel, 'inward_handling_items.xlsx');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
    }
  };
</script>
